export default (state = {}, action) => {
    switch (action.type) {
        case 'ADD_FILTER_PREFERENCE':
            return { ...state, ...action.data };
        case 'CLEAR_FILTER_PREFERENCES':
            return { lastUrl: state.lastUrl };
        case 'SET_LAST_LISTING_URL':
            return { ...state, lastUrl: action.data };
        default:
            return state;
    }
};
